import React, { useEffect, useState } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import { useDispatch, useSelector } from "react-redux";
import BoxLayout from "../../../components/Common/BoxLayout/BoxLayout";
import { createShotclasses } from "../../../utils/mainTabs/manage/createShotclasses";
import {
  getAllVariantLanguagesActionHandler,
  getClassDetailsByIdActionHandler,
  getTrainingTypesActionHandler,
} from "../../../store/actions/actionHandlers/manageActionHandler";
import { getClassDetailsByIdAction } from "../../../store/actions/actionCreators/manageActionCreator";
import { submisssions } from "../../../utils/mainTabs/social/submissions";
import {
  getShotclassSourcingClassDetailsByIdActionHandler,
  updateShotClassSourcingActionHandler,
} from "../../../store/actions/actionHandlers/socialActionHandler";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import loaders from "../../../store/actions/actionCreators/loadersActionCreator";
import {
  setShotClassFormData,
  setViewComments,
} from "../../../store/actions/actionCreators/socialActionCreator";
import { moderateContributions } from "../../../utils/mainTabs/social/moderateContributions";
import { boolean } from "yup";
import useFeatureChecks from "../../../hooks/useFeatureChecks";
import { featureList } from "../../../utils/featureList";

const CreateShotclasses = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const {
    manageTiles,
    setManageTiles,
    setManageButtons,
    tenantName,
    managePath,
    createShotclassesPath,
    edittranscribePath,
    createShotclassesEditPath,
    createShotclassesCopyPath,
    createShotclassesViewPath,
  } = useOutletContext();

  const [allLanguageVariant, setAllLanguageVariant] = useState([]);
  const [trainingTypes, setTrainingTypes] = useState([]);
  const [shotclassTypeFrom, setShotclassTypeFrom] = useState("");
  const [shotclassType, setShotclassType] = useState("create");
  // Add this state near your other useState declarations (around line 60)
  const [isWebinarSelected, setIsWebinarSelected] = useState(false);

  const shotclassTypeFromLocal = localStorage.getItem("shotclassTypeFrom");

  const manageState = useSelector((state) => state.manageReducer);
  const { getClassDetailsById } = manageState;
  const socialState = useSelector((state) => state.socialReducer);
  const { isViewComment, shotClassFormData } = socialState;

  const { tiles: createShotclassTiles } = createShotclasses;

  const { checkMSOMFeature } = useFeatureChecks();
  const languageVariantMenu = {
    roleMenu: "",
    MSOMMenu: featureList?.LANGUAGE_VARIANT,
  };
  const offlineMenu = {
    roleMenu: "",
    MSOMMenu: featureList?.OFFLINE_FEATURE_FOR_SHOTCLASS,
  };
  const slideShareMenu = {
    roleMenu: "",
    MSOMMenu: featureList?.SLIDE_SHARE,
  };

  const [MSOMFeaturesInShotclass, setMSOMFeaturesInShotclass] = useState({
    courseLanguage: true,
    Offline: true,
    slideShare: true,
  });

  let initialFormState = {
    details: {
      Language: "en-GB",
      TrainingType: [],
      ShotClassName: "",
      Content: {
        ContentValue: "",
        ContentMediaType: 0,
        ContentMediaExtension: "",
      },
      ThumbnailImage: "",
      TagSearch: "",
      TagsList: [],
      Description: "",
      Summary: "",
    },
    addQuiz: {
      QuestionsList: [
        {
          Question: "",
          QuestionImage: "",
          ActiveQuestionType: 1,
          IsCorrect: "",
          MultiSelect: false,
          Explanation: "",
          AnswersList: [
            { Answer: "", AnswerImage: "" },
            { Answer: "", AnswerImage: "" },
          ],
        },
      ],
      PassingMarks: "0",
      TotalQuestionCount: 0,
    },
    addSurvey: {
      QuestionsList: [
        {
          Question: "",
          ActiveQuestionType: 1,
          MultiSelect: false,
          IsFreeFormTextBox: false,
          AnswersList: [
            { Answer: "", Score: 0 },
            { Answer: "", Score: 0 },
          ],
        },
      ],
      TotalQuestionCount: 0,
      surveyType: "basic",
      TotalScore: 0,
    },
    publish: {
      Preview: "Desktop",
      OfflineShotclass: false,
      QuestionJumbling: false,
      ShowCorrectAnswers: true,
      CanChangeAnswers: false,
      IsSurveyMandatory: false,
      IsVideoMandatory: false,
      HasRestricted: false,
      IsTrackingEnabled: true, // ✅ Default to true for scored surveys
      ShotclassTargetGroupMapping: [],
    },
  };
  const [formValues, setFormValues] = useState(initialFormState);

  useEffect(() => {
    let shotclassTypeFromVal = location?.state?.from || shotclassTypeFromLocal;
    if (shotclassTypeFromVal) {
      setShotclassTypeFrom(shotclassTypeFromVal);
    }
  }, [location, shotclassTypeFromLocal]);

  useEffect(() => {
    // if (
    //   allLanguageVariant?.length === 0
    //   // &&!location.pathname.includes(createShotclasses.edittranscribepath)
    // ) {
    dispatch(getAllVariantLanguagesActionHandler(setAllLanguageVariant));
    setMSOMFeaturesInShotclass({
      courseLanguage: checkMSOMFeature(languageVariantMenu),
      Offline: checkMSOMFeature(offlineMenu),
      slideShare: checkMSOMFeature(slideShareMenu),
    });
    // }
  }, [
    dispatch,
    // allLanguageVariant
  ]);

  useEffect(() => {
    // if (
    //   trainingTypes?.length === 0
    //   // &&!location.pathname.includes(createShotclasses.edittranscribepath)
    // ) {
    dispatch(
      getTrainingTypesActionHandler(
        "",
        "",
        "",
        setTrainingTypes,
        () => {},
        () => {}
      )
    );
    // }
  }, [
    dispatch,
    // trainingTypes
  ]);

  useEffect(() => {
    if (location.pathname === createShotclassesPath) {
      let tilesList = createShotclassTiles(
        navigate,
        location,
        params,
        tenantName
      );
      if (location.pathname.includes(edittranscribePath)) {
        tilesList = [];
      }
      setManageTiles(tilesList);
      navigate(`${location.pathname}/details`);
    } else if (
      !location.pathname.includes(edittranscribePath) &&
      location.pathname.includes(createShotclassesPath) &&
      manageTiles?.length === 0
    ) {
      navigate(createShotclassesPath);
    } else if (
      location.pathname ===
      submisssions.shotClassespath(params, location, tenantName)
    ) {
      navigate(`${location.pathname}/details`);
      let tilesList = submisssions.tiles(
        navigate,
        location,
        params,
        location.pathname.includes(
          `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
        )
          ? "viewShotclasses"
          : "updateShotclasses",
        tenantName
      );
      setManageTiles(tilesList);
    }
  }, [
    location,
    tenantName,
    params,
    createShotclassesPath,
    edittranscribePath,
    dispatch,
    navigate,
    createShotclassTiles,
    manageTiles?.length,
    setManageTiles,
  ]);

  useEffect(() => {
    if (params?.shotclassId && shotclassTypeFrom) {
      if (
        location.pathname.includes(
          submisssions.shotClassespath(params, location, tenantName)
        )
      ) {
        dispatch(
          getShotclassSourcingClassDetailsByIdActionHandler(
            params?.shotclassId,
            localStorage.getItem("shotclassTypeFrom")
          )
        );
      } else {
        let shotclassStatus =
          shotclassTypeFrom === "myDrafts" ? "Saved" : "Published";
        dispatch(
          getClassDetailsByIdActionHandler(params?.shotclassId, shotclassStatus)
        );
      }
    }
    return () => {
      if (params?.shotclassId && shotclassTypeFrom) {
        dispatch(getClassDetailsByIdAction({}));
      }
    };
  }, [dispatch, params?.shotclassId, shotclassTypeFrom, tenantName]);
  // Handle create mode - when no shotclassId but tiles need to be managed
  useEffect(() => {
    // Hide all tiles if on the transcription page
    if (location.pathname.includes(edittranscribePath)) {
      setManageTiles([]);
      return;
    }
    if (
      !formValues?.ShotclassId &&
      location.pathname.includes(createShotclassesPath)
    ) {
      let tiles = createShotclassTiles(navigate, location, params, tenantName);
      let updatedTiles = tiles.map((tile) => {
        if (tile.path === `${createShotclassesPath}/details`) {
          // Mark details tile as completed if required fields are filled
          if (
            (formValues?.details?.Language ||
              formValues?.details?.Language === "en-GB") &&
            formValues?.details?.ShotClassName &&
            formValues?.details?.TrainingType?.length > 0 &&
            formValues?.details?.TagsList?.length > 0 &&
            formValues?.details?.Summary &&
            formValues?.details?.Description &&
            formValues?.details?.ThumbnailImage
          ) {
            return { ...tile, isCompleted: true };
          }
          return tile;
        } else if (tile.path === `${createShotclassesPath}/addQuiz`) {
          // Hide Add Quiz tile if webinar is selected
          if (isWebinarSelected) {
            return { ...tile, hidden: true };
          }
          return {
            ...tile,
            isCompleted:
              formValues?.addQuiz?.TotalQuestionCount > 0 ? true : false,
            hidden: false, // Show by default for create mode
          };
        } else if (tile.path === `${createShotclassesPath}/addSurvey`) {
          // Hide Add Survey tile if webinar is selected

          if (isWebinarSelected) {
            return {
              ...tile,
              hidden: true,
            };
          }
          return {
            ...tile,
            isCompleted:
              formValues?.addSurvey?.TotalQuestionCount > 0 ? true : false,
            hidden: false, // Show by default for create mode
          };
        }
        return tile;
      });
      debugger;
      setManageTiles(updatedTiles);
    }
  }, [
    // formValues?.ShotclassId,
    // location.pathname,
    // createShotclassesPath,
    isWebinarSelected,
    createShotclassTiles,
    navigate,
    location,
    params,
    tenantName,
    setManageTiles,
    formValues, // <-- add formValues to dependencies so it updates when details change
    edittranscribePath,
  ]);
  useEffect(() => {
    if (
      (location.pathname.includes(createShotclassesEditPath) ||
        location.pathname.includes(createShotclassesCopyPath) ||
        location.pathname.includes(createShotclassesViewPath)) &&
      formValues?.ShotclassId
    ) {
      let tiles = createShotclassTiles(navigate, location, params, tenantName);
      let updatedTiles = tiles.map((tile) => {
        if (tile.path === `${createShotclassesPath}/details`) {
          return { ...tile, isCompleted: true };
        } else if (tile.path === `${createShotclassesPath}/addQuiz`) {
          // Hide Add Quiz tile if webinar is selected
          if (isWebinarSelected) {
            return { ...tile, hidden: true };
          }
          if (
            getClassDetailsById?.ShotClassType !== 1 &&
            getClassDetailsById?.ShotClassType !== 4 &&
            getClassDetailsById?.ShotClassType !== 7 &&
            getClassDetailsById?.Mediatype !== 8 &&
            formValues?.addQuiz?.TotalQuestionCount > 0
          ) {
            return { ...tile, isCompleted: true };
          } else {
            return {
              ...tile,
              hidden:
                getClassDetailsById?.IsDistributed ||
                formValues?.details?.Content?.ContentMediaType === 8
                  ? true
                  : false,
            };
          }
        } else if (tile.path === `${createShotclassesPath}/addSurvey`) {
          // Hide Add Survey tile if webinar is selected
          if (isWebinarSelected) {
            return { ...tile, hidden: true };
          }
          if (
            getClassDetailsById?.ShotClassType !== 1 &&
            getClassDetailsById?.ShotClassType !== 2 &&
            getClassDetailsById?.ShotClassType !== 6 &&
            getClassDetailsById?.Mediatype !== 8 &&
            formValues?.addSurvey?.TotalQuestionCount > 0
          ) {
            return { ...tile, isCompleted: true };
          } else {
            return {
              ...tile,
              hidden:
                getClassDetailsById?.IsDistributed ||
                formValues?.details?.Content?.ContentMediaType === 8
                  ? true
                  : false,
            };
          }
        } else {
          return tile;
        }
      });
      setManageTiles(updatedTiles);
    }
    if (
      location.pathname.includes(moderateContributions.path(tenantName)) &&
      formValues?.ShotclassId
    ) {
      const mode = location.pathname.includes(
        `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
      )
        ? "viewShotclasses"
        : "updateShotclasses";
      let tiles = submisssions.tiles(
        navigate,
        location,
        params,
        mode,
        tenantName
      );
      let updatedTiles = tiles.map((tile) => {
        if (
          tile.path ===
            `${moderateContributions.path(tenantName)}/${mode}/${
              params?.shotclassId
            }/details` &&
          (getClassDetailsById?.Locale || formValues?.details?.Language) &&
          (getClassDetailsById?.ContributorOverview ||
            formValues?.details?.ShotClassName) &&
          (getClassDetailsById?.TrainingTypeId?.length > 0 ||
            formValues?.details?.TrainingType?.length > 0) &&
          (getClassDetailsById?.Tags ||
            formValues?.details?.TagsList?.length > 0) &&
          (getClassDetailsById?.KeyLearning || formValues?.details?.Summary) &&
          (getClassDetailsById?.Description ||
            formValues?.details?.Description) &&
          (getClassDetailsById?.ImageUrl || formValues?.details?.ThumbnailImage)
        ) {
          return { ...tile, isCompleted: true };
        } else if (
          tile.path ===
          `${moderateContributions.path(tenantName)}/${mode}/${
            params?.shotclassId
          }/addQuiz`
        ) {
          // Hide Add Quiz tile if webinar is selected
          if (isWebinarSelected) {
            return { ...tile, hidden: true };
          }
          if (
            getClassDetailsById?.ShotClassType !== 1 &&
            getClassDetailsById?.ShotClassType !== 4 &&
            getClassDetailsById?.ShotClassType !== 7 &&
            getClassDetailsById?.Mediatype !== 8 &&
            formValues?.addQuiz?.TotalQuestionCount > 0
          ) {
            return { ...tile, isCompleted: true };
          } else {
            return {
              ...tile,
              hidden:
                getClassDetailsById?.IsDistributed ||
                formValues?.details?.Content?.ContentMediaType === 8
                  ? true
                  : false,
            };
          }
        } else if (
          tile.path ===
          `${moderateContributions.path(tenantName)}/${mode}/${
            params?.shotclassId
          }/addSurvey`
        ) {
          // Hide Add Survey tile if webinar is selected
          if (isWebinarSelected) {
            return { ...tile, hidden: true };
          }
          if (
            getClassDetailsById?.ShotClassType !== 1 &&
            getClassDetailsById?.ShotClassType !== 2 &&
            getClassDetailsById?.ShotClassType !== 6 &&
            getClassDetailsById?.Mediatype !== 8 &&
            formValues?.addSurvey?.TotalQuestionCount > 0
          ) {
            return { ...tile, isCompleted: true };
          } else {
            return {
              ...tile,
              hidden:
                getClassDetailsById?.IsDistributed ||
                formValues?.details?.Content?.ContentMediaType === 8
                  ? true
                  : false,
            };
          }
        } else {
          return tile;
        }
      });
      // dispatch(() => setShotClassFormData(formValues));
      setManageTiles(updatedTiles);
      // debugger;
    }
    //  else {
    //   //transcription class
    //   setManageTiles([]);
    // }
  }, [
    // dispatch,
    // formValues,
    createShotclassTiles,
    tenantName,
    createShotclassesViewPath,
    createShotclassesCopyPath,
    createShotclassesEditPath,
    createShotclassesPath,
    getClassDetailsById?.IsDistributed,
    getClassDetailsById?.Mediatype,
    formValues?.ShotclassId,
    formValues?.addQuiz?.TotalQuestionCount,
    formValues?.addSurvey?.TotalQuestionCount,
    getClassDetailsById?.ShotClassType,
    // getClassDetailsById?.AssessmentSet?.QuestionList?.length,
    // getClassDetailsById?.Survey?.Questions?.length,
    location,
    navigate,
    params,
    setManageTiles,
    isWebinarSelected,
    setIsWebinarSelected,
  ]);

  useEffect(() => {
    if (
      !formValues.details.ShotClassName &&
      getClassDetailsById?.ID &&
      (location.pathname.includes(createShotclassesEditPath) ||
        location.pathname.includes(createShotclassesCopyPath) ||
        location.pathname.includes(createShotclassesViewPath) ||
        location.pathname.includes(edittranscribePath) ||
        location.pathname.includes(
          submisssions.shotClassespath(params, location, tenantName)
        ))
    ) {
      if (
        location.pathname.includes(createShotclassesEditPath) ||
        location.pathname.includes(
          `${submisssions.updatePath(tenantName)}/${params?.shotclassId}`
        )
      ) {
        setShotclassType("edit");
      } else if (location.pathname.includes(createShotclassesCopyPath)) {
        setShotclassType("copy");
      } else if (
        location.pathname.includes(createShotclassesViewPath) ||
        location.pathname.includes(
          `${submisssions.viewPath(tenantName)}/${params?.shotclassId}`
        )
      ) {
        setShotclassType("view");
      } else if (location.pathname.includes(edittranscribePath)) {
        setShotclassType("editTranscibe");
      }
      if (location.pathname.includes(edittranscribePath)) {
        setFormValues((data) => {
          return {
            ...data,
            Other: { ...getClassDetailsById },
            ShotclassId: getClassDetailsById?.ID,
          };
        });
      } else if (trainingTypes?.length > 0) {
        // Check if this is a webinar training type for copy operations
        const isWebinarClass =
          getClassDetailsById?.TrainingTypeId?.length > 0 &&
          trainingTypes.find(
            (trainingType) =>
              trainingType.TypeId ===
                getClassDetailsById?.TrainingTypeId?.[0] &&
              trainingType.Name?.toLowerCase() === "webinar"
          );

        // Set webinar selected state for copy operations
        if (isWebinarClass) {
          setIsWebinarSelected(true);
        }
        setFormValues((data) => {
          return {
            ...data,
            Other: { ...getClassDetailsById },
            ShotclassId: getClassDetailsById?.ID,
            details: {
              ...data.details,
              Language: getClassDetailsById?.Locale || "en-GB",
              TrainingType:
                getClassDetailsById?.TrainingTypeId?.length > 0
                  ? [
                      {
                        TypeId: getClassDetailsById?.TrainingTypeId?.[0],
                        Name: trainingTypes.find(
                          (trainingType) =>
                            trainingType.TypeId ===
                            getClassDetailsById?.TrainingTypeId?.[0]
                        )?.Name,
                      },
                    ]
                  : [],
              ShotClassName: location.pathname.includes(
                createShotclassesCopyPath
              )
                ? getClassDetailsById?.Name + "_Copy"
                : getClassDetailsById?.Name,
              Content: {
                ContentValue: getClassDetailsById?.VideoUrl,
                ContentMediaType: getClassDetailsById?.Mediatype,
                ContentMediaExtension: "",
              },
              ThumbnailImage: getClassDetailsById?.ImageUrl,
              TagSearch: "",
              TagsList: getClassDetailsById?.Tags?.length
                ? getClassDetailsById?.Tags?.split(",")?.map((val) => ({
                    TagName: val,
                  }))
                : [],
              Description: getClassDetailsById?.KeyLearning,
              Summary: getClassDetailsById?.Description,
              // CalendarUrl: getClassDetailsById?.CalendarUrl,
              // CalendarUrl:
              //   location.pathname.includes(createShotclassesCopyPath) &&
              //   isWebinarClass
              //     ? null // Clear calendar URL for webinar copies
              //     : getClassDetailsById?.CalendarUrl,
              CalendarUrl: location.pathname.includes(createShotclassesCopyPath)
                ? null // Clear calendar URL for webinar copies
                : getClassDetailsById?.CalendarUrl,
            },
            // addQuiz: {
            //   QuestionsList:
            //     getClassDetailsById?.AssessmentSet?.QuestionList?.length > 0
            //       ? getClassDetailsById?.AssessmentSet?.QuestionList?.map(
            //           (question, qIndex) => {
            //             return {
            //               ...question,
            //               ...getClassDetailsById?.AssessmentSet?.QuestionList?.[
            //                 qIndex
            //               ],
            //               Question: question?.Text,
            //               QuestionImage: question?.QuestionImageList?.[0],
            //               Explanation: question?.Explaination,
            //               ActiveQuestionType: question?.Type,
            //               IsCorrect: question?.ChoiceList?.reduce(
            //                 (result, item, index) => {
            //                   if (item?.IsAnswer) {
            //                     if (question?.Type === 1) {
            //                       return index;
            //                     }
            //                     return (
            //                       item?.Text[0].toUpperCase() +
            //                       item?.Text.substr(1).toLowerCase()
            //                     );
            //                   } else {
            //                     return result;
            //                   }
            //                 },
            //                 [0]
            //               ).toString(),
            //               AnswersList: question?.ChoiceList?.map(
            //                 (answer, aIndex) => {
            //                   return {
            //                     ...answer,
            //                     ...getClassDetailsById?.AssessmentSet
            //                       ?.QuestionList?.[qIndex]?.ChoiceList?.[
            //                       aIndex
            //                     ],
            //                     Answer: answer?.Text,
            //                     AnswerImage: answer?.ChoiceImageList || "",
            //                   };
            //                 }
            //               ),
            //             };
            //           }
            //         )
            //       : [
            //           {
            //             Question: "",
            //             QuestionImage: "",
            //             ActiveQuestionType: 1,
            //             IsCorrect: "",
            //             MultiSelect: false,
            //             Explanation: "",
            //             AnswersList: [
            //               { Answer: "", AnswerImage: "" },
            //               { Answer: "", AnswerImage: "" },
            //             ],
            //           },
            //         ],
            //   PassingMarks: getClassDetailsById?.AssessmentSet?.MinScore || 0,
            //   TotalQuestionCount:
            //     getClassDetailsById?.AssessmentSet?.QuestionList?.length || 0,
            // },
            addQuiz: {
              QuestionsList:
                // For webinar copies, don't copy quiz data
                location.pathname.includes(createShotclassesCopyPath) &&
                isWebinarClass
                  ? [
                      {
                        Question: "",
                        QuestionImage: "",
                        ActiveQuestionType: 1,
                        IsCorrect: "",
                        MultiSelect: false,
                        Explanation: "",
                        AnswersList: [
                          { Answer: "", AnswerImage: "" },
                          { Answer: "", AnswerImage: "" },
                        ],
                      },
                    ]
                  : getClassDetailsById?.AssessmentSet?.QuestionList?.length > 0
                  ? getClassDetailsById?.AssessmentSet?.QuestionList?.map(
                      (question, qIndex) => {
                        return {
                          ...question,
                          ...getClassDetailsById?.AssessmentSet?.QuestionList?.[
                            qIndex
                          ],
                          Question: question?.Text,
                          QuestionImage: question?.QuestionImageList?.[0],
                          Explanation: question?.Explaination,
                          ActiveQuestionType: question?.Type,
                          IsCorrect: question?.ChoiceList?.reduce(
                            (result, item, index) => {
                              if (item?.IsAnswer) {
                                if (question?.Type === 1) {
                                  return index;
                                }
                                return (
                                  item?.Text[0].toUpperCase() +
                                  item?.Text.substr(1).toLowerCase()
                                );
                              } else {
                                return result;
                              }
                            },
                            [0]
                          ).toString(),
                          AnswersList: question?.ChoiceList?.map(
                            (answer, aIndex) => {
                              return {
                                ...answer,
                                ...getClassDetailsById?.AssessmentSet
                                  ?.QuestionList?.[qIndex]?.ChoiceList?.[
                                  aIndex
                                ],
                                Answer: answer?.Text,
                                AnswerImage: answer?.ChoiceImageList || "",
                              };
                            }
                          ),
                        };
                      }
                    )
                  : [
                      {
                        Question: "",
                        QuestionImage: "",
                        ActiveQuestionType: 1,
                        IsCorrect: "",
                        MultiSelect: false,
                        Explanation: "",
                        AnswersList: [
                          { Answer: "", AnswerImage: "" },
                          { Answer: "", AnswerImage: "" },
                        ],
                      },
                    ],
              PassingMarks:
                location.pathname.includes(createShotclassesCopyPath) &&
                isWebinarClass
                  ? 0 // Reset passing marks for webinar copies
                  : getClassDetailsById?.AssessmentSet?.MinScore || 0,
              TotalQuestionCount:
                location.pathname.includes(createShotclassesCopyPath) &&
                isWebinarClass
                  ? 0 // Reset question count for webinar copies
                  : getClassDetailsById?.AssessmentSet?.QuestionList?.length ||
                    0,
            },
            // addSurvey: {
            //   QuestionsList:
            //     getClassDetailsById?.Survey?.Questions?.length > 0
            //       ? getClassDetailsById?.Survey?.Questions?.map(
            //           (question, qIndex) => {
            //             return {
            //               ...question,
            //               ...getClassDetailsById?.Survey?.Questions?.[qIndex],
            //               Question: question?.Text,
            //               ActiveQuestionType:
            //                 question?.QuestionType === 2
            //                   ? question?.QuestionType
            //                   : 1,
            //               MultiSelect: question?.QuestionType === 4,
            //               IsFreeFormTextBox: question?.QuestionType === 3,
            //               AnswersList:
            //                 question?.Choices?.length > 0
            //                   ? question?.Choices?.map((answer, aIndex) => {
            //                       return {
            //                         ...answer,
            //                         ...getClassDetailsById?.Survey?.Questions?.[
            //                           qIndex
            //                         ]?.Choices?.[aIndex],
            //                         Answer: answer?.Text,
            //                       };
            //                     })
            //                   : [],
            //             };
            //           }
            //         )
            //       : [
            //           {
            //             Question: "",
            //             ActiveQuestionType: 1,
            //             MultiSelect: false,
            //             IsFreeFormTextBox: false,
            //             AnswersList: [{ Answer: "" }, { Answer: "" }],
            //           },
            //         ],
            //   TotalQuestionCount:
            //     getClassDetailsById?.Survey?.Questions?.length || 0,
            // },
            addSurvey: {
              surveyType:
                getClassDetailsById?.Survey &&
                getClassDetailsById?.Survey?.Type === 1
                  ? "scored"
                  : "basic",
              scoreBands:
                getClassDetailsById?.Survey?.Type === 0
                  ? []
                  : getClassDetailsById?.Survey?.scoreBandConfigs?.map(
                      (band) => {
                        return {
                          ...band,
                          minScore: band?.MinScore,
                          maxScore: band?.Maxscore,
                          feedbackMessage: band?.FeedBackMessage,
                        };
                      }
                    ),
              QuestionsList:
                // For webinar copies, don't copy survey data
                location.pathname.includes(createShotclassesCopyPath) &&
                isWebinarClass
                  ? [
                      {
                        Question: "",
                        ActiveQuestionType: 1,
                        MultiSelect: false,
                        IsFreeFormTextBox: false,
                        AnswersList: [{ Answer: "" }, { Answer: "" }],
                      },
                    ]
                  : getClassDetailsById?.Survey?.Questions?.length > 0
                  ? getClassDetailsById?.Survey?.Questions?.map(
                      (question, qIndex) => {
                        return {
                          ...question,
                          ...getClassDetailsById?.Survey?.Questions?.[qIndex],
                          Question: question?.Text,
                          ActiveQuestionType:
                            question?.QuestionType === 2
                              ? question?.QuestionType
                              : 1,
                          MultiSelect: question?.QuestionType === 4,
                          IsFreeFormTextBox: question?.QuestionType === 3,
                          AnswersList:
                            question?.Choices?.length > 0
                              ? question?.Type === 0
                                ? question?.Choices?.map((answer, aIndex) => {
                                    return {
                                      ...answer,
                                      ...getClassDetailsById?.Survey
                                        ?.Questions?.[qIndex]?.Choices?.[
                                        aIndex
                                      ],
                                      Answer: answer?.Text,
                                    };
                                  })
                                : question?.Choices?.map((answer, aIndex) => {
                                    return {
                                      ...answer,
                                      ...getClassDetailsById?.Survey
                                        ?.Questions?.[qIndex]?.Choices?.[
                                        aIndex
                                      ],
                                      Answer: answer?.Text,
                                      Score: answer?.Grade,
                                    };
                                  })
                              : [],
                        };
                      }
                    )
                  : [
                      {
                        Question: "",
                        ActiveQuestionType: 1,
                        MultiSelect: false,
                        IsFreeFormTextBox: false,
                        AnswersList: [{ Answer: "" }, { Answer: "" }],
                      },
                    ],
              TotalQuestionCount:
                location.pathname.includes(createShotclassesCopyPath) &&
                isWebinarClass
                  ? 0 // Reset survey count for webinar copies
                  : getClassDetailsById?.Survey?.Questions?.length || 0,
            },
            publish: {
              Preview: "Desktop",
              OfflineShotclass: getClassDetailsById?.IsMediaDownloadable,
              QuestionJumbling: getClassDetailsById?.IsRandomQuestionAllowed,
              ShowCorrectAnswers: getClassDetailsById?.ShowCorrectAnswer,
              CanChangeAnswers: getClassDetailsById?.LearnerChangeAnswerOptions,
              IsSurveyMandatory: getClassDetailsById?.Survey?.IsMandatory,
              IsVideoMandatory: getClassDetailsById?.IsVideoMandatory,
              HasRestricted: getClassDetailsById?.IsRestrictedClass,
              LearningContentOnly: getClassDetailsById?.ShotClassType,
              IsTrackingEnabled:
                getClassDetailsById?.Survey?.Type === 1
                  ? getClassDetailsById?.Survey?.IsTrackingEnabled ?? true // ✅ Default to true for scored surveys
                  : false,
              // ✅ Map completion configuration from API response (PascalCase → camelCase)
              isCustomCompletionEnabled: getClassDetailsById?.IsCustomCompletionEnabled ?? false,
              completionConfiguration: getClassDetailsById?.CompletionConfiguration ? {
                completionTitle: getClassDetailsById.CompletionConfiguration.CompletionTitle,
                completionMessage: getClassDetailsById.CompletionConfiguration.CompletionMessage
              } : null,
              ShotclassTargetGroupMapping:
                getClassDetailsById?.ShotclassTargetGroupMapping?.length > 0
                  ? getClassDetailsById?.ShotclassTargetGroupMapping?.map(
                      (tag) => {
                        return {
                          Name: "",
                          UserGroupId: tag.TargetGroupMemberId,
                        };
                      }
                    )
                  : [],
            },
          };
        });
      }
    }
  }, [
    tenantName,
    trainingTypes,
    location,
    createShotclassesViewPath,
    createShotclassesCopyPath,
    createShotclassesEditPath,
    edittranscribePath,
    getClassDetailsById,
    formValues.details.ShotClassName,
    params,
  ]);
  useEffect(() => {
    if (
      location.pathname ===
        `${submisssions.shotClassespath(
          params,
          location,
          tenantName
        )}/details` &&
      formValues
    ) {
      dispatch(setShotClassFormData(formValues));
    }
  }, [formValues, location, params, tenantName, dispatch]);
  return (
    <BoxLayout margin={[0, 0, 0, 0]}>
      <Outlet
        context={{
          initialFormState,
          tenantName,
          manageTiles,
          setManageTiles,
          setManageButtons,
          allLanguageVariant,
          trainingTypes,
          setTrainingTypes,
          shotclassType,
          shotclassTypeFrom,
          formValues,
          setFormValues,
          managePath,
          createShotclassesPath,
          createShotclassesEditPath,
          createShotclassesCopyPath,
          MSOMFeaturesInShotclass,
          isWebinarSelected,
          setIsWebinarSelected,
        }}
      />
    </BoxLayout>
  );
};

export default CreateShotclasses;
